class AdminUserService {

  constructor($http, $rootScope) {
    if ($rootScope && $rootScope.globals)
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;
    this.$http = $http;
  }

  getUsers(roleId) {
    const isAdministrator = roleId === 1 ? true : false;
    return this.$http.get(WEBSERVICEURL + '/dataagility/api/service.person/allusers?administrator=' + isAdministrator);
  }

  putUser(userId, modifiedById, data) {
    return this.$http.put(WEBSERVICEURL + '/dataagility/api/service.person/modifiedBy/' + modifiedById + '/person/' + userId + '/', data);
  }

  postUser(data) {
    return this.$http.post(WEBSERVICEURL + '/dataagility/api/service.person', data);
  }

  getDaysOfTheWeek() {
    return this.$http.get(WEBSERVICEURL + '/dataagility/api/model.day/findAll');
  }
}

class UsersController {
  constructor($http, $scope, LxDialogService, User, Constants, CONST, $sanitize,
    DateFormatter, $rootScope, FunctionService) {

    $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.token;

    this.user = User.getUser();
    this.name = 'User';
    this.specialtyString = '';
    this.options = {
      removeChromeAutoComplete: true
    };
    this.form = "users";
    this.coderOptions = [];
    this.coder = {
      selectedCoder: {
        userSchedule: []
      }
    };
    this.specialty = {
      selectedSpecialty: [],
      specialtyOptions: []
    };
    this.campus = {
      selectedCampus: [],
      campusOptions: []
    };
    this.roles = {
      selectedRole: undefined
    };
    this.roles.rolesOptions = CONST.ROLE;
    if ($rootScope.globals.currentUser.role === 'Manager') {
      this.roles.rolesOptions = ['Auditor', 'CDS', 'Coder', 'Reporter', 'Clerical', 'Manager'];
    }
    this.worklist = {
      selectedWorklist: [],
      worklistOptions: []
    };
    this.codingOperationsTeam = false;
    this.model = {};
    this.userSchedule = [];
    this.userScheduleDays = [];

    this.worklistsFunc = {};

    Constants.lookupsData($scope.vm.user.id, 'worklists').then(
      function successCallback(response) {
          $scope.vm.worklist.worklistOptions = response;
      }
    );

    FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(
      function (response) {
        $scope.vm.functionSettings = response.functionSettings;
        $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
        $scope.vm.worklistsFunc = response.functionSettings.Worklists ? response.functionSettings.Worklists : {};
        $scope.vm.CDIPlatformActive = response.functionSettings.CDI ? response.functionSettings.CDI.isActive : false;
        if ($scope.vm.CDIPlatformActive) {
          $scope.vm.roles.rolesOptions = CONST.ROLE;
          if ($rootScope.globals.currentUser.role === 'Manager') {
            $scope.vm.roles.rolesOptions = ['Auditor', 'CDS', 'Coder', 'Reporter', 'Clerical', 'Manager'];
          }
        } else {
          $scope.vm.roles.rolesOptions = ['Administrator', 'Auditor', 'Coder', 'Clerical', 'Manager', 'Reporter'];
          if ($rootScope.globals.currentUser.role === 'Manager') {
            $scope.vm.roles.rolesOptions = ['Auditor', 'Coder', 'Reporter', 'Clerical', 'Manager'];
          }
        }
      }
    );

    Constants.getDivisionAndSpecialtyData().then(
        function successCallback(response) {
            $scope.vm.specialty.specialtyOptions = response.specialties;
        }
    );

    Constants.campusData().then(
      function successCallback(response) {
        $scope.vm.campus.campusOptions = response;
      }
    );

    new AdminUserService($http, $scope).getDaysOfTheWeek().then(
      function successCallback(response) {
        $scope.vm.userScheduleDays = response.data;
        // If first user hasn't got default scheduled days entered then populate with zero
        if ($scope.vm.coder.selectedCoder.userSchedule.length) {
          angular.forEach($scope.vm.coder.selectedCoder.userSchedule, function(value, key) {
            value.hoursNumber = parseFloat((value.minutes / 60).toFixed(2));
          });
        }
      },
      function errorCallback(response) {
        if (response.status === 401) {
          window.location.replace(window.location.origin + '/login?logout=true');
        }
      }
    );

    new AdminUserService($http, $scope).getUsers($rootScope.globals.currentUser.roleId).then(
      function successCallback(response) {
        angular.forEach(response.data, function(value, key) {
          value.firstname = $sanitize(value.firstname);
          value.lastname = $sanitize(value.lastname);
          $scope.vm.coderOptions.push(value);
        });

        $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0];

        angular.forEach($scope.vm.coder.selectedCoder.userSchedule, function(value, key) {
          value.userId = $scope.vm.coder.selectedCoder.id;
          value.createdById = $scope.vm.user.id;
          value.hoursNumber = parseFloat((value.minutes / 60).toFixed(2));
        });
      },
      function errorCallback(response) {
        if (response.status === 401) {
          window.location.replace(window.location.origin + '/login?logout=true');
        }
      }
    );

    this.addUser = addUser;
    this.coderCallback = coderCallback;
    this.selectCallback = selectCallback;
    this.userScheduleCallback = userScheduleCallback;

    function addUser() {
      // add a new blank user to the model
      var addNew = $scope.vm.coderOptions.push({});
      $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[addNew-1];
      $scope.vm.coder.selectedCoder.dtype = 'Coder';
    }

    function coderCallback(_newValue, _oldValue) {
      if (_newValue.id !== _oldValue.id) {
        if ( $scope.vm.coder.selectedCoder !== $scope.vm.model )
          angular.copy($scope.vm.coder.selectedCoder, $scope.vm.model);

        $scope.vm.model.newPassword = "";
        $scope.vm.model.newPasswordVerify = "";

        var spec,
            specialtyArr = $scope.vm.coder.selectedCoder.specialty;

        if (specialtyArr) {
            spec = specialtyArr.split(',');
        } else {
            spec = [];
        }

        $scope.vm.specialty.selectedSpecialty = [];

        angular.forEach(spec, function(value, key) {
          $scope.vm.specialty.selectedSpecialty.push(value);
        });

        $scope.vm.campus.selectedCampus = [];
        var campus,
          campusArr = $scope.vm.coder.selectedCoder.campus;
        if (campusArr) {
          campus = campusArr.split(',');
        } else {
          campus = [];
        }
        angular.forEach(campus, function(value, key) {
          $scope.vm.campus.selectedCampus.push(value);
        });

        $scope.vm.roles.selectedRole = $scope.vm.coder.selectedCoder.dtype;

        var list,
            worklistArr = $scope.vm.coder.selectedCoder.worklist;

        if (worklistArr) {
            list = worklistArr.split(',');
        } else {
            list = [];
        }

        $scope.vm.worklist.selectedWorklist = [];

        angular.forEach(list, function(value, key) {
          $scope.vm.worklist.selectedWorklist.push(value);
        });

        if ($scope.vm.coder.selectedCoder.userSchedule && !$scope.vm.coder.selectedCoder.userSchedule.length) {
          angular.forEach($scope.vm.userScheduleDays, function(value, key) {
            $scope.vm.coder.selectedCoder.userSchedule.push({dayId: value.dayId, hours: "00:00:00", hoursNumber: 0, minutes: 0, isDeleted: false, userId: $scope.vm.coder.selectedCoder.id, createdById: $scope.vm.user.id});
          });
        }

        angular.forEach($scope.vm.coder.selectedCoder.userSchedule, function(value, key) {
          value.userId = $scope.vm.coder.selectedCoder.id;
          value.createdById = $scope.vm.user.id;
          value.hoursNumber = parseFloat((value.minutes / 60).toFixed(2));
        });

        $scope.vm.model.codingOperationsTeam = $scope.vm.coder.selectedCoder.codingOperationsTeam;

        // reset listener and form state
        $scope.vm.form.$setPristine();
        $scope.vm.form.$setValidity();
        $scope.vm.form.$setUntouched();
      }
    }

    function selectCallback(_newValue, _oldValue) {
      if ($scope.vm.model.specialty !== $scope.vm.specialty.selectedSpecialty.join() ||
          $scope.vm.model.campus !== $scope.vm.campus.selectedCampus.join() ||
          $scope.vm.model.dtype !== $scope.vm.roles.selectedRole ||
          $scope.vm.model.worklist !== $scope.vm.worklist.selectedWorklist.join() ||
          $scope.vm.model.codingOperationsTeam !== $scope.vm.codingOperationsTeam)
          $scope.vm.form.$setDirty();
    }

    function userScheduleCallback(_newValue, _oldValue) {
        if(_newValue !== _oldValue) {
          $scope.vm.form.$setDirty();
        }
    }

    this.openDialog = function() {
        LxDialogService.open("doubleCheck");
    }

    this.checkValid = function() {
      // dis/enable submit button
      if ( $scope.vm.form.$pristine ) {
        return true;
      } else {
        if (Object.keys($scope.vm.form.$error).length === 0 && $scope.vm.form.$error.constructor === Object) {
          return false;
        } else {
          return true;
        }
      }
    }

    this.disableUser = function(userId) {
      // console.log(userId);
      $scope.vm.model.active = false;
      $scope.vm.model.password = '';
      $scope.putData($scope.vm.model);

      angular.forEach($scope.vm.coderOptions, function(value, key) {

        if ( value.id === userId) {

          // remove from options
          $scope.vm.coderOptions.splice(key, 1);
          // display first
          $scope.vm.coder.selectedCoder = $scope.vm.coderOptions[0];

          return;
        }
      });
    }

    this.submitUser = function() {

      // add selects data
      $scope.vm.model.specialty = $scope.vm.specialty.selectedSpecialty.join();
      $scope.vm.model.campus = checkParam($scope.vm.campus.selectedCampus);
      $scope.vm.model.dtype = $scope.vm.roles.selectedRole;
      $scope.vm.model.worklist = $scope.vm.worklist.selectedWorklist.join();
      $scope.vm.model.password = btoa($scope.vm.model.newPasswordVerify);

      // Update hours into minutes
      $scope.vm.model.userSchedule = $scope.vm.coder.selectedCoder.userSchedule;
      angular.forEach($scope.vm.model.userSchedule, function(value, key) {
        value.minutes = parseFloat((value.hoursNumber * 60).toFixed(2));
      });

      if ($scope.vm.model.id) {
          // existing user = put
          $scope.putData($scope.vm.model);
        } else {
          // new user = post
          $scope.vm.model.active = true;
          $scope.postData($scope.vm.model);
        }
    }

    function checkParam(param) {
      if (param.length !== 0) {
        return encodeURIComponent(param.join());
      } else {
        return '';
      }
    }

    $scope.putData = function(data) {

      var userId = data.id,
        data = JSON.stringify(data);

      new AdminUserService($http).putUser(userId, $scope.vm.user.id, data)
        .then(

          function successCallback(response) {

            $scope.vm.coder.selectedCoder = $scope.vm.model;
            $scope.snackBar('User updated');

            // reset listener and form state
            $scope.vm.form.$setPristine();
            $scope.vm.form.$setValidity();
            $scope.vm.form.$setUntouched();
          },
          function errorCallback(response) {
            $scope.snackBar("Database error, error saving User.");
            if (response.status === 401) {
              window.location.replace(window.location.origin + '/login?logout=true');
            }
          });
    }

    $scope.postData = function(data) {

      new AdminUserService($http).postUser(data)
        .then(

          function successCallback(response) {

            // add the ID, so it can be deleted if required
            $scope.vm.model.id = response.data.data;
            angular.copy(data, $scope.vm.coder.selectedCoder);

            $scope.snackBar('User added');

            // reset listener and form state
            $scope.vm.form.$setPristine();
            $scope.vm.form.$setValidity();
            $scope.vm.form.$setUntouched();
          },
          function errorCallback(response) {
            $scope.snackBar("Database error, or email already exists.");
            if (response.status === 401) {
              window.location.replace(window.location.origin + '/login?logout=true');
            }
          });
    }

    $scope.snackBar = function(message) {

      // upgrade MDI components
      window.componentHandler.upgradeAllRegistered();

      var snackbarContainer = document.querySelector('#users__notification');
      var data = {
        message: message,
        timeout: 2000,
        actionHandler: $scope.finaliseCheck,
        actionText: 'test'
      };
      snackbarContainer.MaterialSnackbar.showSnackbar(data);
    }

    this.fields = [
      {
        type: 'lx-input',
        key: 'id',
        hide: true,
        watcher: {
          listener: function(field, newValue, oldValue, scope, stopWatching) {
            if(newValue) {
              scope.model.passwordRequired = false;
            } else {
              scope.model.passwordRequired = true;
            }
          }
        }
      },
      {
        type: 'lx-input',
        key: 'firstname',
        templateOptions: {
          'label': 'First Name',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'lastname',
        templateOptions: {
          'label': 'Surname',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'email',
        templateOptions: {
          type: 'email',
          'label': 'Email Address',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'userName',
        templateOptions: {
          'label': 'PAS Username',
          required: true
        }
      }, {
        type: 'lx-input',
        key: 'newPassword',
        templateOptions: {
          'label': 'New Password (min 12 characters, 1 capital & 1 number)',
          'minlength': 12
        },
        validators: {
          passwordValidation: {
            expression: function(viewValue, modelValue, scope) {
              if (viewValue) {
                if (viewValue.length < 12) {
                  return false;
                } else {
                  var re = /[A-Z].*\d|\d.*[A-Z]/;
                  return re.test(viewValue);
                }
              }
            },
            message: 'Invalid password'
          }
        },
        hideExpression: function ($viewValue, $modelValue, scope) {
          return scope.model.passwordRequired;
        }
      }, {
        type: 'lx-input',
        key: 'newPasswordVerify',
        optionsTypes: ['matchField'],
        templateOptions: {
          'label': 'Confirm New Password - must match New Password',
          'minlength': 12
        },
        data: {
          fieldToMatch: 'newPassword',
          modelToMatch: $scope.vm.model,
          matchFieldMessage: '$viewValue + " does not match " + options.data.modelToMatch.newPassword'
        },
        hideExpression: function ($viewValue, $modelValue, scope) {
          return scope.model.passwordRequired;
        }
      },
      // I couldn't get the expressionProperty.required to work so I've fallen back to show/hide required fields
      {
        type: 'lx-input',
        key: 'newPassword',
        templateOptions: {
          'label': 'New Password - min 12 characters',
          'minlength': 12,
          required: true
        },
        hideExpression: function ($viewValue, $modelValue, scope) {
          return !scope.model.passwordRequired;
        }
      }, {
        type: 'lx-input',
        key: 'newPasswordVerify',
        optionsTypes: ['matchField'],
        templateOptions: {
          'label': 'Confirm New Password - must match New Password',
          'minlength': 12,
          required: true
        },
        hideExpression: function ($viewValue, $modelValue, scope) {
          return !scope.model.passwordRequired;
        },
        data: {
          fieldToMatch: 'newPassword',
          modelToMatch: $scope.vm.model,
          matchFieldMessage: '$viewValue + " does not match " + options.data.modelToMatch.newPassword'
        }
      }
    ];
  }
}

export default UsersController;



// WEBPACK FOOTER //
// ./client/app/common/admin/users/users.controller.js